import * as React from 'react';
import './paymentListPane.module.scss';
import { observer } from 'mobx-react';
import { inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { PaymentListPaneState } from './states/PaymentListPaneState';
import { observable } from 'mobx';
import { BrandIcon } from '../../atoms/cards/BrandIcon';
import { routingStore } from '../../../../common/stores/routing';
import { V3Routes } from '../../../routes';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { BackButtonHeader } from './BackButtonHeader';
import { Pane, PaneHeader, PaneSubHeader } from '../../molecules/mypage/page';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { PaymentView } from './PaymentView';

type Props = {
    homeState: HomePageState;
};

@inject('homeState')
@observer
export class PaymentListPane extends React.Component<Props> {
    @observable pageState = new PaymentListPaneState();

    componentDidMount(): void {
        this.pageState.init();
    }

    render() {
        const cardSummary = this.pageState.cardSummary.getOrElse(null);
        const payments = this.pageState.payments.getOrElse([]);
        return (
            <Pane activeMenu="payments">
                {GlobalStatesV3.viewport.isMobile && <BackButtonHeader to={V3Routes.myPage()} />}
                <PaneHeader>お支払い情報 / 履歴</PaneHeader>
                {this.pageState.cardSummary.loading && <LoaderRow />}
                {cardSummary && (
                    <div styleName="payment-info">
                        <h3 styleName="h3">現在のお支払い情報</h3>
                        <div styleName="card-number">
                            <BrandIcon styleName="brand-icon" brand={cardSummary.brand} />
                            <span styleName="card-number-text">●●●● ●●●● {cardSummary.last4}</span>
                        </div>
                        <div styleName="button" onClick={() => routingStore.push(V3Routes.payment_info())}>
                            変更する
                        </div>
                    </div>
                )}
                {!cardSummary && (
                    <div styleName="payment-info">
                        <h3 styleName="h3">現在のお支払い情報</h3>
                        <div styleName="card-number placeholder">まだお支払い情報が登録されていません。</div>
                        <div styleName="button" onClick={() => routingStore.push(V3Routes.payment_info())}>
                            登録する
                        </div>
                    </div>
                )}
                <PaneSubHeader>お支払い履歴</PaneSubHeader>
                {this.pageState.payments.loading && <LoaderRow />}
                {payments.map((payment, i) => <PaymentView payment={payment} showAction={true} key={i} />)}
            </Pane>
        );
    }
}
